import "./pay.scss"
import CampaignDetailCard, {ICampaignDetailCard} from "../../ui/campaigndetailcard/campaigndetailcard";
import UserCreditCard from "../../ui/usercreditcard/usercreditcard";
import PaymentMethod from "../../ui/paymentmethod/paymentmethod";

const Pay = () => {
    const campaignDetailCardItems: ICampaignDetailCard[] = [
        {name: "کمپین همسان", body1: "1401/09/10", body2: '۲۰ میلیون تومان', link: '#'},
        {name: "کمپین همسان", body1: "1401/09/10", body2: '۲۰ میلیون تومان', link: '#'},
        {name: "کمپین همسان", body1: "1401/09/10", body2: '۲۰ میلیون تومان', link: '#'},
    ]
    return (
        <div className="Pay">
            <div className="container-fluid">
                <div className="row">
                    {
                        campaignDetailCardItems.map((campaignDetailCardItem, index) => {
                            return (
                                <div key={index} className="col-lg-4 col-md-6 col-12 mb-3">
                                    <CampaignDetailCard name={campaignDetailCardItem.name}
                                                        body1={campaignDetailCardItem.body1}
                                                        body2={campaignDetailCardItem.body2}
                                                        link={campaignDetailCardItem.link}/>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-center my-3">
                        <UserCreditCard name="احسان حسینی" credit="7,000,000"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-center my-3">
                        <PaymentMethod money={"12,000,000"}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pay;